module.exports = __webpack_public_path__ + "img/product-img2.4524f57c.png";